import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** shadcn helper - laczy classes z dedup ostatecznych Tailwind utility. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
